import { render, staticRenderFns } from "./BaseNavLinks.vue?vue&type=template&id=1a045573&scoped=true"
import script from "./BaseNavLinks.vue?vue&type=script&lang=js"
export * from "./BaseNavLinks.vue?vue&type=script&lang=js"
import style0 from "./BaseNavLinks.vue?vue&type=style&index=0&id=1a045573&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a045573",
  null
  
)

export default component.exports